import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ButtonComponent } from '@shared/components/button';
import { ConnexionService } from './connexion.service';

@Component({
  selector: 'app-login',
  imports: [ButtonComponent],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  private conServ = inject(ConnexionService);

  annee = new Date().getFullYear();
  login() {
    this.conServ.loginRedirect();
  }
}
